import type { InferValueTypes } from '@/types'
import type { notificationActionCreators } from './actions'

export type NotificationColorType =
  | 'gray'
  | 'topaz'
  | 'orange'
  | 'coral'
  | 'symbol'
  | 'orange-opacity'
  | 'topaz-opacity'
  | 'dusk'
  | 'ai'

export type ToastContainerId = 'main' | 'secondary' | 'socket' | 'ai'

export type NotificationOptions = {
  type: NotificationColorType
  text: string
  toastContainerId: ToastContainerId
  actions?: string[]
  callback?: () => void
  closeCallback?: () => void
  actionText?: string
  preventCloseAfterCallback?: boolean
}

export type NotificationActionCreators = {
  type: NotificationType
  callback?: () => void
  closeCallback?: () => void
  actionText?: string
}

// InitialState for notification reducer
export type InitialState = {
  main: NotificationOptions[]
  secondary: NotificationOptions[]
  socket: NotificationOptions[]
  ai: NotificationOptions[]
}
export enum Actions {
  NOTIFICATION = 'NOTIFICATION',
  SOCKET_NOTIFICATION = 'SOCKET_NOTIFICATION',
  CUSTOM_NOTIFICATION = 'CUSTOM_NOTIFICATION',
  CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION',
  CLEAR_ALL_NOTIFICATION = 'CLEAR_ALL_NOTIFICATION',
}

export enum NotificationType {
  SAVE_PROJECT_SUCCESS = 'SAVE_PROJECT_SUCCESS',
  LIMIT_REACHED = 'LIMIT_REACHED',
  FIGMA_ACCOUNT_OWNER = 'FIGMA_ACCOUNT_OWNER',
  FIGMA_ACCOUNT_ADMIN = 'FIGMA_ACCOUNT_ADMIN',
  MODAL_LINK_COPY_SUCCESS = 'MODAL_LINK_COPY_SUCCESS',
  MODAL_LINK_COPY_LOCKED_SUCCESS = 'MODAL_LINK_COPY_LOCKED_SUCCESS',
  SOMETHING_WENT_WRONG_ERROR = 'SOMETHING_WENT_WRONG_ERROR',
  PROBLEM_WITH_SAVING_CHANGES = 'PROBLEM_WITH_SAVING_CHANGES',
  SAVE_FAILED = 'SAVE_FAILED',
  TEAM_REQUEST_ERROR = 'TEAM_REQUEST_ERROR',
  UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS',
  RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR',
  PASSWORD_PROTECTED_SUCCESS = 'PASSWORD_PROTECTED_SUCCESS',
  PASSWORD_PROTECTED_EMPTY = 'PASSWORD_PROTECTED_EMPTY',
  ACCESS_SETTINGS_UPDATED = 'ACCESS_SETTINGS_UPDATED',
  PROFILE_UPDATED = 'PROFILE_UPDATED',
  PASSWORD_PROTECTED_ERROR = 'PASSWORD_PROTECTED_ERROR',
  PASSWORD_PROTECTED_PASSWORD_ERROR = 'PASSWORD_PROTECTED_PASSWORD_ERROR',
  FETCHING = 'FETCHING',
  AI_GENERATING = 'AI_GENERATING',
  AI_FINISHED = 'AI_FINISHED',
  THANK_YOU = 'THANK_YOU',
  CONNECTING = 'CONNECTING',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  READ_ONLY_VIEW = 'READ_ONLY_VIEW',
  ACTIVITY_HISTORY_PREVIEW = 'ACTIVITY_HISTORY_PREVIEW',
  ARROW_MODE = 'ARROW_MODE',
  SYMBOL_SELECTED = 'SYMBOL_SELECTED',
  COPY_SUCCESS = 'COPY_SUCCESS',
  COPY_FAILED = 'COPY_FAILED',
  INVITATION_SENT = 'INVITATION_SENT',
  FIGMA_FILE_NOT_FOUND = 'FIGMA_FILE_NOT_FOUND',
  TARGET_PAGE_COLLAPSED = 'TARGET_PAGE_COLLAPSED',
  DEBUG_MODE = 'DEBUG_MODE',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  UPLOAD_ATTACHMENT_FILE_ERROR = 'UPLOAD_ATTACHMENT_FILE_ERROR',
  MAX_SIZE_ATTACHMENT_FILE_ERROR = 'MAX_SIZE_ATTACHMENT_FILE_ERROR',
  RENAME_ERROR = 'RENAME_ERROR',
  PAGE_COPIED = 'PAGE_COPIED',
  TREE_COPIED = 'TREE_COPIED',
  SYMBOL_EDITING = 'SYMBOL_EDITING',
  SYMBOL_REPLACEMENT_DONE = 'SYMBOL_REPLACEMENT_DONE',
  COPY_SUCCESSFUL = 'COPY_SUCCESSFUL',
  LINKED_PAGE_IS_OPEN = 'LINKED_PAGE_IS_OPEN',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
}

export type StaticNotification = {
  [key in NotificationType]: NotificationOptions
}

// dynamic type for action creators
export type ActionTypes = ReturnType<
  InferValueTypes<typeof notificationActionCreators>
>
